export default __webpack_public_path__ + "static/media/pic9.b81e15cd.jpg";